import { NavLink } from "react-router-dom";

interface NavTab {
  to: string;
  label: string;
  renderIcon: (isActive: boolean) => JSX.Element;
}

const TABS: NavTab[] = [
  {
    to: "/",
    label: "今日",
    renderIcon: (isActive: boolean) => (
      <svg
        viewBox="0 0 24 24"
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth={isActive ? 1.8 : 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="4" width="18" height="18" rx="3" />
        <path d="M16 2v4M8 2v4M3 10h18" />
        <circle cx="12" cy="15" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    to: "/workout",
    label: "记录",
    renderIcon: (isActive: boolean) => (
      <svg
        viewBox="0 0 24 24"
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth={isActive ? 1.8 : 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <rect x="8" y="2" width="8" height="4" rx="1.5" />
        <path d="M9 14l2 2 4-4" />
      </svg>
    ),
  },
  {
    to: "/profile",
    label: "我的",
    renderIcon: (isActive: boolean) => (
      <svg
        viewBox="0 0 24 24"
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth={isActive ? 1.8 : 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export function BottomNav() {
  return (
    <nav
      aria-label="主导航"
      className="fixed bottom-3 left-4 right-4 max-w-[440px] mx-auto glass-dock rounded-full z-40 px-2 py-1 select-none"
    >
      <div className="grid grid-cols-3 gap-1">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/"}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-h-[48px] rounded-full transition-all duration-150 active:scale-95 ${
                isActive ? "text-tone-accent font-bold" : "text-tone-soft hover:text-tone-ink font-medium"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {/* 顶部 2px 激活短指示条 */}
                <span
                  className={`w-3.5 h-[2px] rounded-full transition-all duration-150 mb-0.5 ${
                    isActive ? "bg-tone-accent opacity-100" : "opacity-0"
                  }`}
                />
                {t.renderIcon(isActive)}
                <span className="text-[11px] leading-tight mt-0.5">{t.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
